import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { tokens } from '@synergy/theme-palo';

const c = tokens.color;

export interface ConvertReceiptLockedProps {
    /** The partner as the document has it — the name is part of the message. */
    name: string;
    /**
     * Which side is locked. The dialog can change neither, so the message
     * says where to go instead — and which field to look for there (Roland
     * Niedermayr, 12.10.2026).
     */
    role: 'customer' | 'supplier';
}

/**
 * Said where a locked partner would otherwise have been carried on.
 *
 * A document keeps its partner as a copy of the master record at the time it
 * was written, so a partner locked since then still stands in it. Following
 * documents and copies may not take that partner on without saying so: "Das
 * System muss das beim Erstellen melden und den Partner zur Neuauswahl leeren"
 * (GF 12.10.2026, #2230). In this dialog there is no partner field to clear —
 * the partner is what the block is — so its positions cannot be picked, and
 * this line says why.
 */
export const ConvertReceiptLocked = ({ name, role }: ConvertReceiptLockedProps): ReactElement => (
    <Box
        role="note"
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            margin: '4px 0 10px',
            padding: '6px 10px',
            borderLeft: `3px solid ${c.crit}`,
            backgroundColor: c.critSoft,
            borderRadius: tokens.radius.small + 'px',
            color: c.ink,
            fontSize: '12px',
        }}
    >
        <FormattedMessage
            id={'supplier' === role ? 'app.convertReceipt.lockedSupplier' : 'app.convertReceipt.lockedCustomer'}
            values={{ name }}
        />
    </Box>
);
